import { createReducer } from 'lib/utilities.js';
const initialState = {
  inquiries: {
    lead_inquiries_state: {},
    lead_analytics_state: {},
  },
};

export default createReducer(initialState, {
  CRM_FETCH_LEAD_INQUIRIES_SUCCESS: (state, payload) => {
    return {
      ...state,
      inquiries: {
        ...state.inquiries,
        lead_inquiries_state: { ...payload },
      },
    };
  },
  CRM_FETCH_LEAD_INQUIRIES_ANALYTICS_SUCCESS: (state, payload) => {
    const historyDataMap = (payload || []).history.reduce((all, item) => {
      all[item.name] = item.value;
      return all;
    }, {});
    const typesByMonthMap = (payload.typesByMonth || []).reduce((all, item) => {
      const stackKeys = Object.keys(item.value);
      all[item.name] = { ...item.value, stackKeys };
      return all;
    }, {});

    const withAddedTotalsByType = (payload.history || []).reduce((all, item) => {
      const mapReference = typesByMonthMap[item.name];
      if (mapReference) {
        all.push({ ...item, ...typesByMonthMap[item.name], stackNames: typesByMonthMap[item.name].stackKeys });
      } else {
        all.push({ ...item });
      }
      return all;
    }, []);

    const withOtherValue = (withAddedTotalsByType || []).map((item) => {
      if (historyDataMap[item.name]) {
        let totalForMonth = historyDataMap[item.name];
        let phoneValue = item['Phone Call'] || 0;
        let webFormValue = item['Web Form'] || 0;
        let totalWebFormAndPhone = phoneValue + webFormValue;

        let otherValue = totalForMonth - totalWebFormAndPhone;
        if (otherValue !== totalForMonth) {
          item['Other'] = otherValue;
        }
      }
      return item;
    });

    const historyFormattedForGraph = { ...payload, history_for_graph: withOtherValue };
    return {
      ...state,
      inquiries: {
        ...state.inquiries,
        lead_analytics_state: historyFormattedForGraph,
      },
    };
  },

  // Failed states
  CRM_FETCH_LEAD_INQUIRIES_ANALYTICS_FAIL: (state, payload) => {
    return {
      ...state,
      inquiries: { ...state.inquiries, lead_inquiries_state: 'failed' },
    };
  },
  CRM_FETCH_LEAD_INQUIRIES_FAIL: (state, payload) => {
    return {
      ...state,
      inquiries: {
        ...state.inquiries,
        lead_inquiries_state: {
          ...state.inquiries.lead_inquiries_state,
          leads: 'failed',
        },
      },
    };
  },
});
